import { render } from "./OutputNode.vue?vue&type=template&id=a2aafc5a&scoped=true"
import script from "./OutputNode.vue?vue&type=script&lang=js"
export * from "./OutputNode.vue?vue&type=script&lang=js"

import "./OutputNode.vue?vue&type=style&index=0&id=a2aafc5a&scoped=true&lang=css"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2aafc5a"]])

export default __exports__